import { Button, Flex, Heading, Text } from '@chakra-ui/react';

import Image from 'next/image';

import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import { configFile } from '@/config';
import { handleGTMClick } from '@/helpers/handleGTMClick';

interface Item {
  title: string;
  description?: string;
}

interface Items {
  items: Item[];
}

export default function Benefits() {
  const { t } = useTranslation('services');
  const router = useRouter();

  const items: Items['items'] = [
    {
      title: `${t('seoConsulting.benefits.items.title1')}`,
      description: `${t('seoConsulting.benefits.items.description1')}`,
    },
    {
      title: `${t('seoConsulting.benefits.items.title2')}`,
      description: `${t('seoConsulting.benefits.items.description2')}`,
    },
    {
      title: `${t('seoConsulting.benefits.items.title3')}`,
      description: `${t('seoConsulting.benefits.items.description3')}`,
    },
    {
      title: `${t('seoConsulting.benefits.items.title4')}`,
      description: `${t('seoConsulting.benefits.items.description4')}`,
    },
    {
      title: `${t('seoConsulting.benefits.items.title5')}`,
      description: `${t('seoConsulting.benefits.items.description5')}`,
    },
    {
      title: `${t('seoConsulting.benefits.items.title6')}`,
      description: `${t('seoConsulting.benefits.items.description6')}`,
    },
  ];

  return (
    <Flex direction="column" maxWidth="1216px" margin="0 auto" width={{ base: '90%', lg: '100%' }} mb="32px">
      <Flex
        bgColor={configFile.secondaryAccentColor}
        width="100%"
        direction="column"
        p={{ base: '24px', lg: '80px' }}
        alignItems="center"
        justifyContent="center"
        borderRadius="16px"
        gap="64px"
      >
        <Heading
          as="h2"
          fontSize={{ base: '36px', lg: '48px' }}
          lineHeight={{ base: '40px', lg: '48px' }}
          fontWeight={{ base: '700', lg: '800' }}
          textAlign="center"
          color={configFile.tertiaryAccentColor}
        >
          {t('seoConsulting.benefits.title')}
        </Heading>

        <Flex
          direction={{ base: 'column', lg: 'row' }}
          flexWrap="wrap"
          alignItems="center"
          justifyContent="center"
          columnGap={{ base: '32px', lg: '32px' }}
          rowGap={{ base: '64px', lg: '64px' }}
        >
          {items.map((item, index) => (
            <Flex key={index} gap="8px" alignItems="flex-start" maxW="331px">
              <Image
                src={
                  index === 0
                    ? '/images/benefits/icon1.svg'
                    : /* eslint-disable */
                    index === 1
                    ? '/images/benefits/icon2.svg'
                    : index === 2
                    ? '/images/benefits/icon3.svg'
                    : index === 3
                    ? '/images/benefits/icon4.svg'
                    : index === 4
                    ? '/images/benefits/icon5.svg'
                    : '/images/benefits/icon6.svg'
                }
                alt="icon"
                style={{ marginBottom: '16px' }}
                width={56}
                height={56}
              />
              <Flex direction="column" gap="8px" maxW="266px">
                <Text as="h3" color="teal.400" fontSize="18px" fontWeight="700" lineHeight="28px">
                  {item.title}
                </Text>
                <Text as="p" color={configFile.tertiaryAccentColor} fontSize="16px" lineHeight="24px">
                  {item.description}
                </Text>
              </Flex>
            </Flex>
          ))}
        </Flex>
        <Button
          id="scenario_contact"
          onClick={(e) => handleGTMClick(e, () => router.push('/contato'))}
          aria-label="contact page"
          size="lg"
          w={{ base: '100%', lg: '336px' }}
          h="72px"
          p="10px 24px"
          bgColor="teal.500"
          color={configFile.tertiaryAccentColor}
          _hover={{ bgColor: 'teal.400' }}
        >
          {t('seoConsulting.benefits.button')}
        </Button>
      </Flex>
    </Flex>
  );
}
